import React from 'react';
import { Navigate, RouteProps } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Urls, useAuth } from '../../context';

interface LenderRouteProps extends RouteProps {
	excludeTeamMembers: boolean;
}

const LenderRoute: React.FC<LenderRouteProps> = props => {
	const auth = useAuth();

	if (props.excludeTeamMembers) {
		return auth.isAuthenticated && auth.currentUser.isBankUser && !auth.isTeamMember ? (
			<Outlet />
		) : (
			<Navigate to={Urls.Documents.Root} />
		);
	}

	return auth.isAuthenticated && auth.currentUser.isBankUser ? <Outlet /> : <Navigate to={Urls.Documents.Root} />;
};

export default LenderRoute;
